import React from "react";
import debounce from "lodash.debounce";
// 引入HOC高阶函数withTranslation 和 i18n的ts类型定义WithTranslation
import { withTranslation, WithTranslation } from "react-i18next";
import Nav from "./Nav";
import "../../assets/styles/newStyle.scss";
import "../../assets/styles/secondPage.scss";
class EBUComponent extends React.Component<WithTranslation> {
  state = {
    scale: "",
    imageWidth: "",
    imageHeight: "",
    navForm: null,
    scrollTop: null,
    topIconShow: false,
    topClick: false,
  };
  componentWillUnmount() {
    this.setState = () => false;
    window.removeEventListener("scroll", this.handleScroll.bind(this));
  }
  componentDidMount() {
    setTimeout(() => {
      this.setState({ scale: this.getScale() });
    }, 500);
    window.addEventListener("resize", this.setScale);
    window.addEventListener("scroll", this.handleScroll.bind(this));
  }
  handleScroll = () => {
    //滚动条高度
    let scrollTop = document.documentElement.scrollTop; //滚动条滚动高度
    // console.log(scrollTop);
    // console.log(this.state.scale)
    if (scrollTop >= 300) {
      this.setState({
        topIconShow: true,
      });
    } else {
      this.setState({
        topIconShow: false,
      });
    }
  };
  // 将子组件传过来的实例赋值给navForm
  onRef = (ref) => {
    // eslint-disable-next-line
    this.state.navForm = ref;
    this.state.navForm.setState({
      background_is_black: false,
    });
    // console.log(this.state.navForm);
  };
  // 导航栏跳页面
  toPage = (index) => {
    // console.log(index);
    this.props.history.push("/");
    window.localStorage.setItem("swiperPage", index);
  };
  // 返回首页
  toPageHome = () => {
    this.props.history.push("/");
  };
  // 语言切换
  langChange = () => {
    // console.log("语言切换");
    const { i18n } = this.props;
    i18n.changeLanguage(i18n.language === "zh_cn" ? "en" : "zh_cn");
    // this.state.player.load();
    // this.state.mySwiper.disable()
  };
  //得到呈现的屏幕宽高比
  getScale = () => {
    const { width = 1028 } = this.props;
    let ww = window.innerWidth / width;
    return ww < 1 ? 1 : ww;
  };
  setScale = debounce(() => {
    let scale = this.getScale();
    this.setState({ scale });
  }, 500);
  // 滚动页面
  toMore = () => {
    window.location.hash = "";
    window.location.hash = "disk";
    // this.refDom.scrollTop = 100 * this.state.scale;
  };
  toLayer_1 = () => {
    window.location.hash = "";
    window.location.hash = "layer_1";
  };
  toLayer_2 = () => {
    window.location.hash = "";
    window.location.hash = "layer_2";
  };
  toLayer_3 = () => {
    window.location.hash = "";
    window.location.hash = "layer_3";
  };
  // 回到顶部
  toTop = () => {
    this.setState({
      topClick: true,
    });
    // this.refDom.scrollTop = 0;
    // 缓冲
    const timer = setInterval(() => {
      // 再次获取滚动条距顶部高度
      var osTop = this.refDom.scrollTop;
      // 用于设置速度差,产生缓慢效果
      var speed = Math.floor(-osTop / 8);
      this.refDom.scrollTop = osTop = osTop + speed;
      if (osTop === 0) {
        clearInterval(timer);
        this.setState({
          topClick: false,
        });
      }
    }, 30);
  };
  // 二级页面
  toSecondPage = (page) => [this.props.history.push("/" + page)];
  render() {
    const { t, i18n } = this.props;
    const { scale, topClick, topIconShow } = this.state;
    return (
      <div
        className="EBU"
        ref={(ref) => {
          this.refDom = ref;
        }}
        style={{
          height: topClick ? "100vh" : "auto",
        }}
      >
        {/* 导航栏 */}
        <Nav
          onRef={this.onRef}
          navIndex={2}
          langChange={this.langChange}
          toPageSwiper={this.toPage}
          toSecondPage={this.toSecondPage}
          logoClick={this.toPageHome}
          navList={t("navList")}
          navListLevel={t("navListLevel")}
          lang={i18n.language}
          className={"nav-no-fixed"}
        />
        <div className="secondPage-container">
          <img
            className="EBU_bg"
            src={require("@/assets/images/EBU_bg.png").default}
            alt=""
          />
          {/* 了解更多 */}
          <div
            className="area_click"
            onClick={this.toMore}
            style={{
              width: `${140 * scale}px`,
              height: `${35 * scale}px`,
              top: `${187 * scale}px`,
              left: `${133 * scale}px`,
            }}
          />
          {/* 圆盘锚点 */}
          <div
            id="disk"
            className="area_click"
            style={{
              width: `${140 * scale}px`,
              height: `${35 * scale}px`,
              top: `${240 * scale}px`,
              left: `${130 * scale}px`,
            }}
          ></div>
          {/* 核心层 */}
          <div
            className="area_click"
            onClick={this.toLayer_1}
            style={{
              width: `${120 * scale}px`,
              height: `${120 * scale}px`,
              top: `${450 * scale}px`,
              left: `${352 * scale}px`,
            }}
          />
          {/* 核心层锚点 */}
          <div
            id="layer_1"
            className="area_click"
            style={{
              width: `${140 * scale}px`,
              height: `${35 * scale}px`,
              top: `${825 * scale}px`,
              left: `${130 * scale}px`,
            }}
          ></div>
          {/* 接入层 */}
          <div
            className="area_click"
            onClick={this.toLayer_2}
            style={{
              width: `${185 * scale}px`,
              height: `${60 * scale}px`,
              top: `${576 * scale}px`,
              left: `${325 * scale}px`,
            }}
          />
          {/* 接入锚点 */}
          <div
            id="layer_2"
            className="area_click"
            style={{
              width: `${140 * scale}px`,
              height: `${35 * scale}px`,
              top: `${1680 * scale}px`,
              left: `${130 * scale}px`,
            }}
          ></div>
          {/* 业务层 */}
          <div
            className="area_click"
            onClick={this.toLayer_3}
            style={{
              width: `${185 * scale}px`,
              height: `${60 * scale}px`,
              top: `${650 * scale}px`,
              left: `${325 * scale}px`,
            }}
          />
          {/* 业务层锚点 */}
          <div
            id="layer_3"
            className="area_click"
            style={{
              width: `${140 * scale}px`,
              height: `${35 * scale}px`,
              bottom: `${950 * scale}px`,
              left: `${130 * scale}px`,
            }}
          ></div>
          {/* 商务合作 */}
          <div
            className="area_click"
            style={{
              width: `${140 * scale}px`,
              height: `${35 * scale}px`,
              bottom: `${118 * scale}px`,
              left: `${440 * scale}px`,
            }}
          />
        </div>
        {/* 返回顶部 */}
        {topIconShow ? (
          <div className="toTop" onClick={this.toTop}>
            <img src={require("@/assets/images/toTop.png").default} alt="" />
          </div>
        ) : null}
      </div>
    );
  }
}
export const EBU = withTranslation()(EBUComponent); // 使用withTranslation高阶函数来完成语言配置的数据注入
